import React, { useEffect, useState } from 'react'
import '../dashboard.css'
import tmsLogoWhite from '../img/TMS LOGO WHITE.svg'
import shypvLogoWhite from '../img/Shypv Logo SVG White.svg'
import Plan from './pages/Plan'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import OrdersView from './pages/OrdersView'
import DriverConfig from './pages/DriverConfig'
import PlanDispatch from './pages/PlanDispatch'
import Dashboard from './pages/Dashboard'
import AllOrders from './pages/AllOrders'
import InScan from './pages/InScan'
import NewInScan from './pages/NewInScan'
import NewInScanModern from './pages/NewInScanModern'
import InScan1 from './pages/InScan1'
import ChangeStatus from './pages/ChangeStatus'
import OutScan from './pages/OutScan'
import DriverRunsheet from './pages/DriverRunsheet'
import StorePickups from './pages/StorePickups'
import GetTracking from './pages/GetTracking'
import GetDriverOrders from './pages/GetDriverOrders'
import GetDriverOrdersbyRange from './pages/GetDriverOrdersbyRange'
import BulkScan from './pages/BulkScan'
import CardandCustom from './pages/CardandCustom'
import Consent from './pages/Consent'
import Documentation from './pages/Documentation'
import Confirmation from './pages/Confirmation'
import TaskCreation from './pages/TaskCreation'
import NormalTaskCreationOld from './pages/NormalTaskCreationOld'
import NewNormalTaskCreation from './pages/NewNormalTaskCreation'
import NewMedicalTaskCreation from './pages/NewMedicalTaskCreation'
import RegularTaskNormal from './pages/RegularTaskNormal'
import RegularTaskMedical from './pages/RegularTaskMedical'
import SupportTickets from './pages/SupportTickets'
import GetDriverMedicalOrders from './pages/GetDriverMedicalOrders'
import GetMedicalOrders from './pages/GetMedicalOrders'
import BulkPrint from './pages/BulkPrint'
import UpdateManualAWB from './pages/UpdateManualAWB'
import AddressCorrection from './pages/AddressCorrection'
import CxUpdate from './pages/CxUpdate'
import AccountsReport from './pages/AccountsReport'
import GeneratePartnerBill from './pages/GeneratePartnerBill'
import BillingUpdate from './pages/BillingUpdate'
import BillingOrders from './pages/BillingOrders'
import Projects from './pages/Projects'
import InScanCutoffConfig from './pages/InScanCutoffConfig'
import MobileAppVersions from './pages/MobileAppVersions'
import OutScan2 from './pages/OutScan2'
import AttendanceSetting from './pages/AttendanceSetting'
import AttendanceConfig from './pages/AttendanceConfig'
import AttendanceReport from './pages/AttendanceReport'
import AttendanceSettingEdit from './pages/AttendanceSettingEdit'
import BulkScanAsync from './pages/BulkScanAsync'
import AttendanceConfigDriver from './pages/AttendanceConfigDriver'
import AddAttendance from './pages/AddAttendance'
import PrintLabel from './pages/PrintLabel'
import OrderSync from './pages/OrderSync'
import ZonesList from './pages/ZonesList'
import ZoneForm from './pages/ZoneForm'
import ServicesList from './pages/ServicesList'
import PriceRangesList from './pages/PriceRangesList'
import MedicalAttendanceConfig from './pages/MedicalAttendanceConfig'
import MedicalAttendanceSetting from './pages/MedicalAttendanceSetting'
import MedicalAttendanceGeofence from './pages/MedicalAttendanceGeofence'
import MedicalAttendanceDrivers from './pages/MedicalAttendanceDrivers'
// Emirates scan pages hidden — replaced by LiveScanMonitor, which pulls per-env from
// api.shypv.com / staging-api.shypv.com. Imports kept (commented) so they can be
// re-enabled by uncommenting if needed.
// import EmiratesUpdates from './pages/EmiratesUpdates'
// import EmiratesScanMonitor from './pages/EmiratesScanMonitor'
// import EmiratesScanV2 from './pages/EmiratesScanV2'
import LiveScanMonitor from './pages/LiveScanMonitor'
import PowerTools from './pages/PowerTools'
import MedicalOrderMover from './pages/MedicalOrderMover'
import OrderDetails from './pages/OrderDetails'
import LiveOrderDetail from './pages/LiveOrderDetail'
import Monitoring from './pages/Monitoring'
import FleetPConnect from './pages/FleetPConnect'
import FleetPAttendance from './pages/FleetPAttendance'
import FleetPKmNotings from './pages/FleetPKmNotings'
import FleetPDailyRecords from './pages/FleetPDailyRecords'
import FleetPDataView from './pages/FleetPDataView'
import DriverAttendanceTest from './pages/DriverAttendanceTest'
import SmsMonitoring from './pages/SmsMonitoring'
import MedicalOrderGenerator from './pages/MedicalOrderGenerator'
import EntityManagement from './pages/EntityManagement'
import DriverWallets from './pages/DriverWallets'
import SupervisorCollections from './pages/SupervisorCollections'
import WalletSetup from './pages/WalletSetup'
import AccountantWallet from './pages/AccountantWallet'
import AwbCustody from './pages/AwbCustody'
import DutiesTax from './pages/DutiesTax'
import DriverWalletDetail from './pages/DriverWalletDetail'
import ForwardedShipments from './pages/ForwardedShipments'
import ForwardedShipmentDetail from './pages/ForwardedShipmentDetail'
export default function Sidebar() {
  const location = useLocation(); // Get the current URL path
  const segment = useParams()
  const currentSegment = segment['*']
  const APP_VERSION = process.env.REACT_APP_VERSION || '1.1.0';

  useEffect(() => {
    if (!sessionStorage.getItem('userid')) {
      navigate('/login');  // Redirect to login page
    }
  }, []);
  // const currentSegment = segment || location.pathname.split('/')[2]; // Fallback to path if no segment from params
  const path = window.location.pathname;  // '/dashboard'

  const pathname = path.split('/').pop();  // 'dashboard'


  const navigate = useNavigate();  // Initialize navigate to use for redirect

  function logOut() {
    // Clear all session data
    sessionStorage.removeItem('userid');
    sessionStorage.removeItem('usertoken');
    sessionStorage.removeItem('user_name');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('useremail');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('branch');
    
    // Clear all local storage data to prevent auto-login
    localStorage.removeItem('userid');
    localStorage.removeItem('usertoken');
    localStorage.removeItem('user_name');
    localStorage.removeItem('username');
    localStorage.removeItem('name');
    localStorage.removeItem('useremail');
    localStorage.removeItem('role');
    localStorage.removeItem('branch');
    
    navigate('/login');  // Redirect to login page
  }

  const [isMinimized, setIsMinimized] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  // Toggle function for the sidebar state
  const toggleSidebar = () => {
    setIsMinimized(prevState => !prevState);
  };

  const [isReportsOpen, setReportsOpen] = useState(false);
  const [isBankingOpen, setBankingOpen] = useState(false);

  // Function to toggle the reports menu
  const toggleReportsMenu = () => {
    setReportsOpen(!isReportsOpen);
  };

  const toggleBankingMenu = () => {
    setBankingOpen(!isBankingOpen);
  };
  const [isScanOpen, setScanOpen] = useState(false);

  // Function to toggle the reports menu
  const toggleScanMenu = () => {
    setScanOpen(!isScanOpen);
  };


   const [isAccountsOpen, setAccountsOpen] = useState(false);

  // Function to toggle the reports menu
  const toggleAccountsMenu = () => {
    setAccountsOpen(!isAccountsOpen);
  };

     const [isAttendanceOpen, setAttendanceOpen] = useState(false);

  // Function to toggle the reports menu
  const toggleAttendanceMenu = () => {
    setAttendanceOpen(!isAttendanceOpen);
  };

  const [isTaskOpen, setTaskOpen] = useState(false);

  // Function to toggle the reports menu
  const toggleTaskMenu = () => {
    setTaskOpen(!isTaskOpen);
  };

  const [isPricingOpen, setPricingOpen] = useState(false);

  // Function to toggle the pricing strategies menu
  const togglePricingMenu = () => {
    setPricingOpen(!isPricingOpen);
  };

  const [isMedicalAttendanceOpen, setMedicalAttendanceOpen] = useState(false);

  // Function to toggle the medical attendance menu
  const toggleMedicalAttendanceMenu = () => {
    setMedicalAttendanceOpen(!isMedicalAttendanceOpen);
  };

  // Collapsed by default like every other sidebar group; the route-based effect below still
  // auto-opens it when you are actually on one of the Custom Tools pages.
  const [isCustomToolsOpen, setCustomToolsOpen] = useState(false);

  // Function to toggle the custom tools menu
  const toggleCustomToolsMenu = () => {
    setCustomToolsOpen(!isCustomToolsOpen);
  };

  const [isEmiratesV2Open, setEmiratesV2Open] = useState(false);
  const toggleEmiratesV2Menu = () => {
    setEmiratesV2Open(!isEmiratesV2Open);
  };

  const [isMedicalOrdersOpen, setMedicalOrdersOpen] = useState(false);

  const toggleMedicalOrdersMenu = () => {
    setMedicalOrdersOpen(!isMedicalOrdersOpen);
  };

  const [isShypvOpen, setShypvOpen] = useState(false);
  const [isFleetPConnected, setFleetPConnected] = useState(false);

  // Function to toggle the Shypv integrations menu
  const toggleShypvMenu = () => {
    setShypvOpen(!isShypvOpen);
  };

  // Check FleetP connection status
  useEffect(() => {
    const checkFleetPStatus = () => {
      const connected = sessionStorage.getItem('fleetp_connected') === 'true';
      setFleetPConnected(connected);
    };
    
    // Check on mount
    checkFleetPStatus();
    
    // Listen for storage changes (when FleetPConnect updates the status)
    const handleStorageChange = () => {
      checkFleetPStatus();
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically for same-tab updates
    const interval = setInterval(checkFleetPStatus, 1000);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === '/orders/get-driver-tracking') {
      setReportsOpen(true)
    }
    if (location.pathname === '/orders/get-driver-report') {
      setReportsOpen(true)
    }
    if (location.pathname === '/orders/inscan') {
      setScanOpen(true)
    }
    if (location.pathname === '/orders/outscan') {
      setScanOpen(true)
    }
    if (location.pathname === '/orders/bulkscan') {
      setScanOpen(true)
    }
    if (location.pathname === '/orders/print-label') {
      setScanOpen(true)
    }
    if (location.pathname === '/orders/tasks') {
      setTaskOpen(true)
    }
    if (location.pathname === '/orders/normal-task') {
      setTaskOpen(true)
    }
    if (location.pathname === '/orders/new-medical-task' || location.pathname === '/orders/new-normal-task') {
      setTaskOpen(true)
    }
    if (location.pathname === '/orders/regular-task-normal' || location.pathname === '/orders/regular-task-medical') {
      setTaskOpen(true)
    }
    if (location.pathname === '/orders/order-sync') {
      setTaskOpen(true)
    }
    if (location.pathname === '/orders/cx-update') {
      setAccountsOpen(true)
    }
     if (location.pathname === '/orders/billing-update') {
      setAccountsOpen(true)
    }
    if (location.pathname === '/orders/partner-bill') {
      setAccountsOpen(true)
    }
    if (location.pathname === '/orders/driver-wallets' || location.pathname.startsWith('/orders/driver-wallets/')) {
      setAccountsOpen(true)
    }
    if (location.pathname === '/orders/awb-custody') {
      setAccountsOpen(true)
    }

    if (location.pathname === '/orders/driver-medical-orders') {
      setBankingOpen(true)
    }
    if (location.pathname === '/orders/medical-orders') {
      setBankingOpen(true)
    }

    if (location.pathname === '/orders/attendance-setting') {
      setAttendanceOpen(true)
    }
    
    if (location.pathname === '/orders/attendance-config' ||location.pathname === '/orders/attendance-config-driver' || location.pathname ==='/orders/add-attendance') {
      setAttendanceOpen(true)
    }
    
    // Auto-open Pricing menu for zones pages
    if (location.pathname === '/orders/zones' || location.pathname.startsWith('/orders/zones/')) {
      setPricingOpen(true)
    }
    if (location.pathname === '/orders/services' || location.pathname.startsWith('/orders/services/')) {
      setPricingOpen(true)
    }
    if (location.pathname === '/orders/price-ranges' || location.pathname.startsWith('/orders/price-ranges/')) {
      setPricingOpen(true)
    }
    
    // Auto-open Medical Attendance menu
    if (location.pathname.includes('/orders/medical-attendance')) {
      setMedicalAttendanceOpen(true)
    }
    
    // Auto-open Custom Tools menu
    if (
      location.pathname.includes('/orders/live-scan-monitor') ||
      location.pathname.includes('/orders/order-details') ||
      location.pathname.includes('/orders/sms-monitoring') ||
      location.pathname.includes('/orders/power-tools') ||
      location.pathname.includes('/orders/medical-order-mover') ||
      location.pathname.includes('/orders/monitoring') ||
      location.pathname.includes('/orders/new-inscan') ||
      location.pathname.includes('/orders/order-sync') ||
      location.pathname.includes('/orders/fleetp-connect') ||
      location.pathname.includes('/orders/fleetp-attendance') ||
      location.pathname.includes('/orders/fleetp-km') ||
      location.pathname.includes('/orders/fleetp-daily') ||
      location.pathname.includes('/orders/fleetp-data') ||
      location.pathname.includes('/orders/driver-test')
    ) {
      setCustomToolsOpen(true)
    }
    // Auto-open Reports menu
    if (
      location.pathname.includes('/orders/get-driver-tracking') ||
      location.pathname.includes('/orders/get-driver-report') ||
      location.pathname.includes('/orders/accounts-report') ||
      location.pathname.includes('/orders/medical-orders') ||
      location.pathname.includes('/orders/driver-medical-orders') ||
      location.pathname.includes('/orders/medical-order-generator') ||
      location.pathname.includes('/orders/attendance-report')
    ) {
      setReportsOpen(true)
    }
  }, [])


  function downloadAPK() {
    // Determine base URL based on current hostname
    const currentHost = window.location.hostname;
    let fileUrl;
    let apktype;

    if (currentHost.includes('stage-tms-dashboard.shypv.com')) {
      fileUrl = process.env.PUBLIC_URL + "/apk/stage.apk";
      apktype='stage';
    } else {
      fileUrl = process.env.PUBLIC_URL + "/apk/prod.apk";
      apktype='prod';
    }



    // Create a temporary link element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", `${apktype}-tms-app.ap`); // Suggests filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

   const currentHost = window.location.hostname;

       
          

  return (
    <div>
      <title>Login - Locus Dashboard</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" />
      {/* <style dangerouslySetInnerHTML={{__html: "\n\t\t\n\t" }} /> */}
      <div id="react-root" className="dashboardWelcome notranslate" notranslate="true">
        <div >

          {/* <div style={{ height: '115vh', width: '300px', overflowY: 'auto', background: '#06003c', padding: '1rem' }}>
            {Array.from({ length: 50 }).map((_, i) => (
              <div key={i}>Sidebar Item {i + 1}</div>
            ))}
          </div> */}

          <div className="rr-dasholder">
            {/* Mobile overlay */}
            <div
              className={`sidebar-overlay ${isMobileOpen ? 'active' : ''}`}
              onClick={() => setIsMobileOpen(false)}
            />
            {/* Mobile hamburger */}
            <button className="sidebar-mobile-toggle" onClick={() => setIsMobileOpen(true)} aria-label="Open menu">
              <i className="fa fa-bars" style={{ fontSize: 16 }} />
            </button>

            <div className="left_bardashboard_wrap">
              <div className={`left_bar ${isMobileOpen ? 'mobile-open' : ''}`}>
                {/* ── Header ─────────────────────────────────── */}
                <div className="sb-logo-header">
                  <img src={tmsLogoWhite} alt="TMS Logo" />
                </div>
                {/* ── Nav items ──────────────────────────────── */}
                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/dashboard' ? 'looa4_active' : ''}`}
                  testid="insightsSideBar" href="/dashboard">
                  <i className="fa fa-pie-chart css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Dashboard</span>
                </a>
                {/* <a className= {`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/tasks' ? 'looa4_active' : ''}`} testid="insightsSideBar"  href="/orders/tasks">							
                    <i className="fa fa-calendar-check-o css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Task</span>
                  </a> */}


                <div className="LeftBar__collapse" style={{
                  display: sessionStorage.getItem('role') === 'super_admin' ? 'block' : 'block'
                }}>
                  <a
                    className="LeftBar__item___looa4 tooltip-icon"
                    testid="insightsSideBar"

                    onClick={toggleTaskMenu}
                  >

                    <i className="fa fa-tasks css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Tasks</span>
                    <span className={`sb-chevron ${isTaskOpen ? 'open' : ''}`} />
                  </a>


                  {isTaskOpen && (
                    <div className="LeftBar__subMenu">


                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/tasks' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/tasks">
                        <i className="fa fa-solid fa-plus css-zfl09c" aria-hidden="true" />

                        <span className="leftbar_title">Medical Task</span>
                      </a>

                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/normal-task' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/normal-task">
                        <i className="fa fa-truck css-zfl09c" aria-hidden="true" />

                        <span className="leftbar_title">Normal Task </span>
                      </a>

                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/new-medical-task' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/new-medical-task">
                        <i className="fa fa-solid fa-plus css-zfl09c" aria-hidden="true" />

                        <span className="leftbar_title">New Medical Task</span>
                      </a>

                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/new-normal-task' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/new-normal-task">
                        <i className="fa fa-truck css-zfl09c" aria-hidden="true" />

                        <span className="leftbar_title">New Normal Task </span>
                      </a>

                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/regular-task-normal' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/regular-task-normal">
                        <i className="fa fa-repeat css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Regular Task (Normal)</span>
                      </a>

                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/regular-task-medical' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/regular-task-medical">
                        <i className="fa fa-repeat css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Regular Task (Medical)</span>
                      </a>

                    </div>
                  )}
                </div>

                <div className="LeftBar__collapse">
                  <a
                    className="LeftBar__item___looa4 tooltip-icon"
                    testid="insightsSideBar"

                    onClick={toggleScanMenu}
                  >

                    <i className="fa fa-barcode css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Scans</span>
                    <span className={`sb-chevron ${isScanOpen ? 'open' : ''}`} />
                  </a>


                  {isScanOpen && (
                    <div className="LeftBar__subMenu">


                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/inscan' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/inscan">
                        <i className="fa fa-solid fa-barcode css-zfl09c" aria-hidden="true" />

                        <span className="leftbar_title">InScan</span>
                      </a>
 {currentHost.includes('stage-tms-dashboard.shypv.com')?(
 <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/inscan2' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/inscan2">
                        <i className="fa fa-solid fa-barcode css-zfl09c" aria-hidden="true" />

                        <span className="leftbar_title">InScan (Async)</span>
                      </a>
 ):''
}
                      

                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/outscan' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/outscan">
                        <i className="fa fa-outdent css-zfl09c" aria-hidden="true" />

                        <span className="leftbar_title">Pickup /Out </span>
                      </a>
                       {currentHost.includes('stage-tms-dashboard.shypv.com')?(
                       <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/outscan2' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/outscan2">
                        <i className="fa fa-outdent css-zfl09c" aria-hidden="true" />

                        <span className="leftbar_title">Pickup /Out (Async)</span>
                      </a>
                       ):''
}
                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/bulkscan' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/bulkscan"
                      >
                        <i className="fa fa-solid fa-barcode css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Bulk Scan</span>
                      </a>

                   {currentHost.includes('stage-tms-dashboard.shypv.com')?(
                         <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/bulkscan-async' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/bulkscan-async"
                      >
                        <i className="fa fa-solid fa-barcode css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Bulk Scan Async</span>
                      </a> 
                        ):""}

                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/print-label' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/print-label"
                      >
                        <i className="fa fa-print css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Print Label</span>
                      </a>
                      
                    </div>
                  )}
                </div>




                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/runsheet' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/runsheet">
                  <i className="fa fa-user css-zfl09c" aria-hidden="true" />

                  <span className="leftbar_title">Run sheet      </span>
                </a>
                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/store-pickups' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/store-pickups">
                  <i className="fa fa-shopping-bag css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Store Pickups</span>
                </a>
                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/allorders' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/allorders">
                  <i className="fa fa-location-arrow css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Live View</span>
                </a>

                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/forwarded-shipments' || location.pathname.startsWith('/orders/forwarded-shipments/') ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/forwarded-shipments">
                  <i className="fa fa-share-square-o css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Forwarded Orders</span>
                </a>

                 
                <div className="LeftBar__collapse"   >
                  <a
                    className="LeftBar__item___looa4 tooltip-icon"
                    testid="insightsSideBar"

                    onClick={toggleAttendanceMenu}
                  >

                    <i className="fa fa-calendar-check-o css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Attendance Conf</span>
                    <span className={`sb-chevron ${isAttendanceOpen ? 'open' : ''}`} />
                  </a>


                  {isAttendanceOpen && (
                    <div className="LeftBar__subMenu">


                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/attendance-setting' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/attendance-setting">
                  <i className="fa fa-plus-circle css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Add Config</span>
                </a>
                 <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/attendance-config' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/attendance-config">
                  <i className="fa fa-cogs css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Partner Config</span>
                </a>
                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/attendance-config-driver' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/attendance-config-driver">
                  <i className="fa fa-users css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Driver Config</span>
                </a>

                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/add-attendance' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/add-attendance">
                  <i className="fa fa-calendar-plus-o css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Add Attendance</span>
                </a>
                    
                    </div>
                  )}
                </div>


                 <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/address-correction' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/address-correction">
                  <i className="fa fa-map css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Address Correction</span>
                </a>  
                 


                
                <div className="LeftBar__collapse">
                  <a
                    className="LeftBar__item___looa4 tooltip-icon"
                    testid="insightsSideBar"

                    onClick={toggleAccountsMenu}
                  >

                    <i className="fa fa-university css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Accounts Use</span>
                    <span className={`sb-chevron ${isAccountsOpen ? 'open' : ''}`} />
                  </a>


                  {isAccountsOpen && (
                    <div className="LeftBar__subMenu">


                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/cx-update' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/cx-update">
                  <i className="fa fa-user-circle-o css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">CX Update</span>
                </a>

                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/billing-update' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/billing-update">
                  <i className="fa fa-credit-card css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Billing Update</span>
                </a>

                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/billing-orders' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/billing-orders">
                  <i className="fa fa-file-text-o css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Billing Orders</span>
                </a>

                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/awb-custody' && (!location.search || location.search.includes('from-driver')) ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/awb-custody?tab=from-driver">
                  <i className="fa fa-truck css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Driver Collection</span>
                </a>

                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/awb-custody' && location.search.includes('from-supervisor') ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/awb-custody?tab=from-supervisor">
                  <i className="fa fa-user-secret css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Supervisor Collection</span>
                </a>

                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/awb-custody' && location.search.includes('to-company') ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/awb-custody?tab=to-company">
                  <i className="fa fa-university css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Account Submit</span>
                </a>

                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/duties-tax' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/duties-tax">
                  <i className="fa fa-percent css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Duties &amp; Tax</span>
                </a>

                     <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/partner-bill' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/partner-bill">
                  <i className="fa fa-calculator css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Partner Bill</span>
                </a>

                    </div>
                  )}
                </div>

                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/projects' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/projects">
                  <i className="fa fa-folder-open css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Projects</span>
                </a>

                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/inscan-cutoff' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/inscan-cutoff">
                  <i className="fa fa-clock-o css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Service Time Cutoff</span>
                </a>

                <a  className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/manual-awb' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/manual-awb">
                  <i className="fa fa-location-arrow css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Manual AWB Update</span>
                </a>

                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/bulkprint' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/bulkprint">
                  <i className="fa fa-print css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Bulk Print</span>
                </a>
                {sessionStorage.getItem('role') && (sessionStorage.getItem('role') == 'super_admin' || sessionStorage.getItem('role') == 'admin') ? (
                  <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/entity/homebase' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/entity/homebase">
                    <i className="fa fa-database css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Entity Management</span>
                  </a>
                ) : ''
                }
                {sessionStorage.getItem('role') && ['super_admin', 'admin', 'support'].includes(sessionStorage.getItem('role')) ? (
                  <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/support-tickets' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/support-tickets">
                    <i className="fa fa-life-ring css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Support Tickets</span>
                  </a>
                ) : ''
                }

                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/mobile-app' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/mobile-app">
                  <i className="fa fa-mobile css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Mobile App</span>
                </a>

                {/* Pricing Strategies Menu */}
                <div className="LeftBar__collapse">
                  <a
                    className="LeftBar__item___looa4 tooltip-icon"
                    testid="insightsSideBar"
                    onClick={togglePricingMenu}
                  >
                    <i className="fa fa-money css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Pricing Strategies</span>
                    <span className={`sb-chevron ${isPricingOpen ? 'open' : ''}`} />
                  </a>

                  {isPricingOpen && (
                    <div className="LeftBar__subMenu">
                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/zones' || location.pathname.startsWith('/orders/zones/') ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/zones"
                      >
                        <i className="fa fa-map-marker css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Zones</span>
                      </a>
                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/services' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/services"
                      >
                        <i className="fa fa-truck css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Services</span>
                      </a>
                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/price-ranges' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/price-ranges"
                      >
                        <i className="fa fa-tags css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Price Ranges</span>
                      </a>
                    </div>
                  )}
                </div>

                {/* Medical Attendance Menu */}
                <div className="LeftBar__collapse">
                  <a
                    className="LeftBar__item___looa4 tooltip-icon"
                    testid="insightsSideBar"
                    onClick={toggleMedicalAttendanceMenu}
                  >
                    <i className="fa fa-medkit css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Medical Attendance</span>
                    <span className={`sb-chevron ${isMedicalAttendanceOpen ? 'open' : ''}`} />
                  </a>

                  {isMedicalAttendanceOpen && (
                    <div className="LeftBar__subMenu">
                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/medical-attendance-config' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/medical-attendance-config"
                      >
                        <i className="fa fa-cogs css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Partner Config</span>
                      </a>
                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/medical-attendance-setting' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/medical-attendance-setting"
                      >
                        <i className="fa fa-plus-circle css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Add Config</span>
                      </a>
                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/medical-attendance-geofence' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/medical-attendance-geofence"
                      >
                        <i className="fa fa-map-marker css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Locations</span>
                      </a>
                      <a
                        className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/medical-attendance-drivers' ? 'looa4_active' : ''}`}
                        testid="insightsSideBar"
                        href="/orders/medical-attendance-drivers"
                      >
                        <i className="fa fa-users css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Driver Config</span>
                      </a>
                    </div>
                  )}
                </div>

                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/update-status' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/update-status">
                  <i className="fa fa-solid fa-list-ul  css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Update Status</span>
                </a>
                <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/get-tracking' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/get-tracking">
                  <i className="fa fa-solid fa-search css-zfl09c" aria-hidden="true" />
                  <span className="leftbar_title">Bulk Tracking</span>
                </a>

                <div className="LeftBar__collapse">
                  <a
                    className="LeftBar__item___looa4 tooltip-icon"
                    testid="insightsSideBar"

                    onClick={toggleReportsMenu}
                  >

                    <i className="fa fa-bar-chart css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Reports</span>
                    <span className={`sb-chevron ${isReportsOpen ? 'open' : ''}`} />
                  </a>


                  {isReportsOpen && (
                    <div className="LeftBar__subMenu">
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/get-driver-tracking' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/get-driver-tracking">
                        <i className="fa fa-truck css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Driver Orders</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/get-driver-report' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/get-driver-report">
                        <i className="fa fa-bar-chart css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Orders Report</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/accounts-report' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/accounts-report">
                        <i className="fa fa-university css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Accounts Report</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/attendance-report' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/attendance-report">
                        <i className="fa fa-calendar-check-o css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Attendance Report</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/medical-orders' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/medical-orders">
                        <i className="fa fa-heartbeat css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Medical Report</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/driver-medical-orders' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/driver-medical-orders">
                        <i className="fa fa-user-md css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Driver Med Orders</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/medical-order-generator' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/medical-order-generator">
                        <i className="fa fa-file-text css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Medical Order Reports</span>
                      </a>
                    </div>
                  )}
                </div>

                {/* Custom Tools Menu */}
                <div className="LeftBar__collapse">
                  <a
                    className="LeftBar__item___looa4 tooltip-icon"
                    testid="insightsSideBar"
                    onClick={toggleCustomToolsMenu}
                  >
                    <i className="fa fa-wrench css-zfl09c" aria-hidden="true" />
                    <span className="leftbar_title">Custom Tools</span>
                    <span className={`sb-chevron ${isCustomToolsOpen ? 'open' : ''}`} />
                  </a>

                  {isCustomToolsOpen && (
                    <div className="LeftBar__subMenu">
                      {/* Emirates scan entries hidden — replaced by Live Scan Monitor below */}
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/live-scan-monitor' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/live-scan-monitor">
                        <i className="fa fa-broadcast-tower css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Live Scan Monitor</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/order-details' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/order-details">
                        <i className="fa fa-list-alt css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Order Details</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/sms-monitoring' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/sms-monitoring">
                        <i className="fa fa-envelope css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">SMS Monitoring</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/monitoring' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/monitoring">
                        <i className="fa fa-line-chart css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">System Monitor</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/new-inscan' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/new-inscan">
                        <i className="fa fa-qrcode css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">New InScan</span>
                        <span style={{ fontSize:'9px', fontWeight:700, background:'linear-gradient(90deg,#f59e0b,#fbbf24,#f59e0b)', backgroundSize:'200% auto', animation:'sbGoldShine 1.8s linear infinite', color:'#fff', padding:'2px 6px', borderRadius:'4px', marginLeft:'6px', letterSpacing:'0.5px', boxShadow:'0 1px 4px rgba(245,158,11,0.5)' }}>NEW</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/new-inscan-modern' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/new-inscan-modern">
                        <i className="fa fa-magic css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">InScan (Modern)</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/order-sync' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/order-sync">
                        <i className="fa fa-refresh css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Order Sync</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/power-tools' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/power-tools">
                        <i className="fa fa-bolt css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Power Tools</span>
                      </a>
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/medical-order-mover' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/medical-order-mover">
                        <i className="fa fa-exchange css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Medical Order Mover</span>
                      </a>
                      {/* Shypv / FleetP */}
                      <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/fleetp-connect' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/fleetp-connect">
                        <i className="fa fa-plug css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">FleetP Connect</span>
                        {isFleetPConnected && <span style={{ fontSize: '10px', backgroundColor: '#22c55e', color: '#fff', padding: '2px 6px', borderRadius: '4px', marginLeft: '8px' }}>LIVE</span>}
                      </a>
                      {isFleetPConnected && (
                        <>
                          <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/fleetp-data' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/fleetp-data">
                            <i className="fa fa-database css-zfl09c" aria-hidden="true" />
                            <span className="leftbar_title">FleetP Sent Data</span>
                          </a>
                          <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/fleetp-attendance' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/fleetp-attendance">
                            <i className="fa fa-calendar-check-o css-zfl09c" aria-hidden="true" />
                            <span className="leftbar_title">FleetP Attendance</span>
                          </a>
                          <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/fleetp-km' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/fleetp-km">
                            <i className="fa fa-road css-zfl09c" aria-hidden="true" />
                            <span className="leftbar_title">FleetP KM Notings</span>
                          </a>
                          <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/fleetp-daily' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/fleetp-daily">
                            <i className="fa fa-file-text-o css-zfl09c" aria-hidden="true" />
                            <span className="leftbar_title">FleetP Daily Records</span>
                          </a>
                          <a className={`LeftBar__item___looa4 tooltip-icon ${location.pathname === '/orders/driver-test' ? 'looa4_active' : ''}`} testid="insightsSideBar" href="/orders/driver-test">
                            <i className="fa fa-id-card-o css-zfl09c" aria-hidden="true" />
                            <span className="leftbar_title">Driver Attendance</span>
                          </a>
                        </>
                      )}
                    </div>
                  )}
                </div>


                <div className="LeftBar__helpSection___wcwpo" style={{width: '100%', boxSizing: 'border-box'}}>
                  <div >
                    {/* <div className="NotificationBell__notificationBell___platform_VeNx8">
                        <a className="LeftBar__item___looa4 tooltip-icon" testid="insightsSideBar" href="#">							
                          <i className="fa fa-bell css-zfl09c" aria-hidden="true" />
                          <div className="NotificationBell__placeholder___platform_B8WWU NotificationBell__badge___platform_kISIT">0</div>
                          <span className="t-ooltiptext t-ooltip-right">Alerts</span>
                        </a>
                      </div>
                      <a className="LeftBar__item___looa4 tooltip-icon" testid="insightsSideBar" href="#">							
                        <i className="fa fa-cog css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Account &amp; Administration</span>
                      </a>
                      <a className="LeftBar__item___looa4 tooltip-icon" testid="insightsSideBar" href="#">							
                        <i className="fa fa-question-circle css-zfl09c" aria-hidden="true" />
                        <span className="leftbar_title">Help &amp; Support</span>
                      </a> */}
                  </div>
                </div>
                {/* User Profile Section */}
                <div style={{width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderTop: '1px solid rgba(255,255,255,0.1)'}}>
                  <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', padding: '12px 10px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '10px', marginBottom: '10px', width: '100%', boxSizing: 'border-box'}}>
                    <div style={{width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#00a6ed', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', fontWeight: 'bold', color: '#fff'}}>
                      {sessionStorage.getItem('user_name')?.charAt(0)?.toUpperCase() || 'U'}
                    </div>
                    <div style={{textAlign: 'center'}}>
                      <div style={{fontSize: '13px', fontWeight: '500', color: '#fff'}}>
                        {sessionStorage.getItem('user_name') || 'User'}
                      </div>
                      <div style={{fontSize: '11px', color: 'rgba(255,255,255,0.6)'}}>
                        {sessionStorage.getItem('role') || 'Staff'}
                      </div>
                    </div>
                  </div>
                  <div style={{display: 'flex', gap: '8px', marginBottom: '10px', justifyContent: 'center', width: '100%'}}>
                    <button onClick={downloadAPK} style={{flex: 1, padding: '8px', backgroundColor: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '6px', color: '#fff', fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'}}>
                      <i className="fa fa-download" aria-hidden="true"></i> APK
                    </button>
                    <button onClick={logOut} style={{flex: 1, padding: '8px', backgroundColor: '#dc3545', border: 'none', borderRadius: '6px', color: '#fff', fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'}}>
                      <i className="fa fa-sign-out" aria-hidden="true"></i> Sign Out
                    </button>
                  </div>
                </div>
                {/* Powered by and Version at bottom of sidebar */}
                <div style={{padding: '10px', textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.1)', width: '100%', boxSizing: 'border-box', display: 'block'}}>
                  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: '5px', width: '100%'}}>
                    <span style={{fontSize: '10px', color: 'rgba(255,255,255,0.5)'}}>Powered by</span>
                    <img src={shypvLogoWhite} alt="Shypv" style={{height: '12px', width: 'auto'}} />
                  </div>
                  <span style={{fontSize: '10px', color: 'rgba(255,255,255,0.5)', display: 'block', textAlign: 'center'}}>v{APP_VERSION}</span>
                </div>
              </div>
            </div>
            <div className="rr-dascontenthol">
              <div className="rr-dascon1">
                <div className="rr-dascon2">
                  {/* Transparent gap at top */}
                  <div style={{height: '20px', backgroundColor: 'transparent'}}></div>
                  {currentSegment === 'orders' && <Plan />}
                  {currentSegment === 'view' && <OrdersView />}
                  {currentSegment === 'configure' && <DriverConfig />}
                  {currentSegment === 'dispatch' && <PlanDispatch />}
                  {currentSegment === 'allorders' && <AllOrders />}
                  {pathname === 'dashboard' && <Dashboard />}
                  {pathname === 'inscan' && <InScan />}
                  {pathname === 'new-inscan' && <NewInScan />}
                  {pathname === 'new-inscan-modern' && <NewInScanModern />}
                  {/* {pathname === 'inscan' && <InScan1 />} */}
                  {pathname === 'outscan' && <OutScan />}
                  {/* {pathname === 'outscan' && <OutScan2 />} */}
                  {pathname === 'bulkscan' && <BulkScan />}
                  {pathname === 'bulkscan-async' && <BulkScanAsync />}
                  {pathname === 'print-label' && <PrintLabel />}
                  {pathname === 'runsheet' && <DriverRunsheet />}
                  {pathname === 'store-pickups' && <StorePickups />}
                  {pathname === 'update-status' && <ChangeStatus />}
                  {pathname === 'get-tracking' && <GetTracking />}
                  {pathname === 'get-driver-tracking' && <GetDriverOrders />}
                  {pathname === 'get-driver-report' && <GetDriverOrdersbyRange />}
                  {pathname === 'driver-medical-orders' && <GetDriverMedicalOrders />}
                  {pathname === 'medical-orders' && <GetMedicalOrders />}
                  {pathname === 'card-custom-data' && <CardandCustom />}
                  {pathname === 'consent' && <Consent />}
                  {pathname === 'documentation' && <Documentation />}
                  {pathname === 'confirmation' && <Confirmation />}
                  {pathname === 'bulkprint' && <BulkPrint />}
                  {pathname === 'manual-awb' && <UpdateManualAWB />}
                  {pathname === 'address-correction' && <AddressCorrection />}
                  {pathname === 'cx-update' && <CxUpdate />}
                  {pathname === 'billing-update' && <BillingUpdate />}
                  {pathname === 'billing-orders' && <BillingOrders />}
                  {pathname === 'projects' && <Projects />}
                  {pathname === 'inscan-cutoff' && <InScanCutoffConfig />}
                  {pathname === 'accounts-report' && <AccountsReport />}
                  {pathname === 'partner-bill' && <GeneratePartnerBill />}

                  {/* Driver Wallets */}
                  {pathname === 'driver-wallets' && <DriverWallets />}
                  {(pathname.match(/^\d+$/) && location.pathname.includes('/driver-wallets/')) && <DriverWalletDetail driverId={pathname} />}
                  {pathname === 'supervisor-collections' && <SupervisorCollections />}
                  {pathname === 'accountant-wallet' && <AccountantWallet />}
                  {pathname === 'awb-custody' && <AwbCustody />}
                  {pathname === 'wallet-setup' && <WalletSetup />}

                  {/* Forwarded Orders (external carrier legs — proxied from the main backend) */}
                  {pathname === 'forwarded-shipments' && <ForwardedShipments />}
                  {(pathname.match(/^\d+$/) && location.pathname.includes('/forwarded-shipments/')) && <ForwardedShipmentDetail shipmentId={pathname} />}
                  {pathname === 'duties-tax' && <DutiesTax />}
                  {pathname === 'attendance-setting' && <AttendanceSetting />}

                  
                  {pathname === 'attendance-config' && <AttendanceConfig />}
                  {pathname === 'attendance-config-driver' && <AttendanceConfigDriver />}
                  {pathname === 'add-attendance' && <AddAttendance />}
                  {pathname === 'attendance-report' && <AttendanceReport />}
                  {pathname === 'editattendance' && <AttendanceSettingEdit />}

                  {pathname === 'tasks' && <TaskCreation />}
                  {pathname === 'normal-task' && <NormalTaskCreationOld />}
                  {pathname === 'new-medical-task' && <NewMedicalTaskCreation />}
                  {pathname === 'new-normal-task' && <NewNormalTaskCreation />}
                  {pathname === 'regular-task-normal' && <RegularTaskNormal />}
                  {pathname === 'regular-task-medical' && <RegularTaskMedical />}
                  {pathname === 'support-tickets' && <SupportTickets />}
                  {pathname === 'mobile-app' && <MobileAppVersions />}
                  {pathname === 'order-sync' && <OrderSync />}
                  
                  {/* Pricing Strategies - Zones */}
                  {pathname === 'zones' && <ZonesList />}
                  {(pathname === 'create' && location.pathname.includes('/zones/')) && <ZoneForm />}
                  {(pathname.match(/^\d+$/) && location.pathname.includes('/zones/edit/')) && <ZoneForm />}
                  
                  {/* Pricing Strategies - Services */}
                  {pathname === 'services' && <ServicesList />}
                  
                  {/* Pricing Strategies - Price Ranges */}
                  {pathname === 'price-ranges' && <PriceRangesList />}
                  
                  {/* Medical Attendance */}
                  {pathname === 'medical-attendance-config' && <MedicalAttendanceConfig />}
                  {pathname === 'medical-attendance-setting' && <MedicalAttendanceSetting />}
                  {pathname === 'medical-attendance-geofence' && <MedicalAttendanceGeofence />}
                  {pathname === 'medical-attendance-drivers' && <MedicalAttendanceDrivers />}
                  
                  {/* Custom Tools */}
                  {/* Emirates pages hidden — replaced by LiveScanMonitor (CRM-driven per env) */}
                  {/* {pathname === 'emirates-updates' && <EmiratesUpdates />} */}
                  {/* {pathname === 'emirates-scan-monitor' && <EmiratesScanMonitor />} */}
                  {/* {pathname === 'emirates-scan-v2' && <EmiratesScanV2 />} */}
                  {pathname === 'live-scan-monitor' && <LiveScanMonitor />}
                  {pathname === 'order-details' && <OrderDetails />}
                  {pathname === 'order-details-view' && <LiveOrderDetail />}
                  {pathname === 'sms-monitoring' && <SmsMonitoring />}
                  {pathname === 'power-tools' && <PowerTools />}
                  {pathname === 'medical-order-mover' && <MedicalOrderMover />}

                  {/* Medical Orders */}
                  {pathname === 'medical-order-generator' && <MedicalOrderGenerator />}
                  
                  {/* Shypv Integrations */}
                  {pathname === 'fleetp-connect' && <FleetPConnect />}
                  {pathname === 'fleetp-attendance' && <FleetPAttendance />}
                  {pathname === 'fleetp-km' && <FleetPKmNotings />}
                  {pathname === 'fleetp-daily' && <FleetPDailyRecords />}
                  {pathname === 'fleetp-data' && <FleetPDataView />}
                  {pathname === 'driver-test' && <DriverAttendanceTest />}
                  
                  {/* System Monitoring */}
                  {pathname === 'monitoring' && <Monitoring />}

                  {/* Entity Management */}
                  {['homebase','personnel','team','rider','vehicle-model','vehicle','devices','partner-warehouse'].includes(pathname) && <EntityManagement />}
                  
                  {/* {segment === 'orders' && <Plan />}
                    {segment === 'view' && <OrdersView />}
                    {segment === 'configure' && <DriverConfig />}
                    {segment === 'dispatch' && <PlanDispatch />}
                    {segment === '' && <Dashboard />} */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
